import { render } from "./ProductGroup.vue?vue&type=template&id=9e2c3254&ts=true"
import script from "./ProductGroup.vue?vue&type=script&lang=ts"
export * from "./ProductGroup.vue?vue&type=script&lang=ts"

import exportComponent from "D:\\YellowBeardProject\\caffeine\\caffeineshopadmin\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__